import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import pertamina from '../../../images/clients/pertamina.png'
import exxon from '../../../images/clients/exxon.png'
import indosat from '../../../images/clients/Indosat.png'
import logo_perusahaan_1 from '../../../images/clients/logo_perusahaan1.jpg'
import sjr from '../../../images/clients/sjr.jpeg'
import mst from '../../../images/clients/mst.jpeg'
import kpp from '../../../images/clients/kpp.png'
import CK from '../../../images/clients/CK.png'
import PPA_TABANG from '../../../images/clients/PPA_TABANG.png'
import PPA_SBS from '../../../images/clients/PPA_SBS.png'
import pamapersada from '../../../images/clients/pamapersada.png'
import mml from '../../../images/clients/mml.png'
import images from '../../../images/clients/images.jpeg'
import emp from '../../../images/clients/emp.png'
import bis from '../../../images/clients/bis.png'
import bsi from '../../../images/clients/BSI.png'
import brantas from '../../../images/clients/brantas.png'
import AIMS from '../../../images/clients/aims.png'
import TeleNet from '../../../images/clients/telenet.png'

const partners = [
    {
        pImg: bsi,
    },
    {
        pImg: brantas,
    },
    {
        pImg: pertamina,
    },
    {
        pImg: exxon,
    },
    {
        pImg: indosat,
    },
    {
        pImg: logo_perusahaan_1,
    },
    {
        pImg: sjr,
    },
    {
        pImg: mst,
    },
    {
        pImg: kpp,
    },
    {
        pImg: CK,
    },
    {
        pImg: PPA_SBS,
    },
    {
        pImg: PPA_TABANG,
    },
    {
        pImg: pamapersada,
    },
    {
        pImg: mml,
    },
    {
        pImg: images,
    },
    {
        pImg: emp,
    },
    {
        pImg: bis,
    },
    {
        pImg: AIMS,
    },
    {
        pImg: TeleNet,
    },
]

var settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    pauseOnHover: false,
    pauseOnFocus: false,

    responsive: [
        {
            breakpoint: 1025,
            settings: {
                slidesToShow: 7,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 450,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 350,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
};



const FeaturePartners = (props) => {

    return (
        <div className="feature_partners_section">
            <div className="container position-relative">
                <div className="title_text text-white">
                    Our Costumer
                </div>
                <div className="client_logo_carousel">
                    <Slider {...settings}>
                        {partners.map((partner, pitem) => (
                            <div className="client_logo_item" key={pitem}>
                                <img src={partner.pImg} alt="Panca Pilar - Customer" width={80} />
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default FeaturePartners;
